var map = {
	"./academy-courses": [
		2231,
		7,
		2231
	],
	"./academy-courses.js": [
		2231,
		7,
		2231
	],
	"./academy-slider": [
		8376,
		9,
		3660,
		8376
	],
	"./academy-slider.js": [
		8376,
		9,
		3660,
		8376
	],
	"./affiliate-dashboard": [
		7368,
		9,
		7368
	],
	"./affiliate-dashboard.js": [
		7368,
		9,
		7368
	],
	"./affiliate-form": [
		3252,
		7,
		3252
	],
	"./affiliate-form.js": [
		3252,
		7,
		3252
	],
	"./affiliate-payments": [
		3369,
		9,
		3660,
		3369
	],
	"./affiliate-payments.js": [
		3369,
		9,
		3660,
		3369
	],
	"./affiliate-withdrawals": [
		1752,
		9,
		3660,
		1752
	],
	"./affiliate-withdrawals.js": [
		1752,
		9,
		3660,
		1752
	],
	"./asset-price-animation": [
		6621,
		7,
		6621
	],
	"./asset-price-animation.js": [
		6621,
		7,
		6621
	],
	"./b2b-demo": [
		1476,
		9,
		1476
	],
	"./b2b-demo.js": [
		1476,
		9,
		1476
	],
	"./best-time-invest": [
		2054,
		7,
		2054
	],
	"./best-time-invest.js": [
		2054,
		7,
		2054
	],
	"./blog-categories": [
		2721,
		7,
		2721
	],
	"./blog-categories-dropdown": [
		5675,
		7,
		5675
	],
	"./blog-categories-dropdown.js": [
		5675,
		7,
		5675
	],
	"./blog-categories.js": [
		2721,
		7,
		2721
	],
	"./blog-page": [
		2646,
		7,
		2646
	],
	"./blog-page.js": [
		2646,
		7,
		2646
	],
	"./blue-cards-slider": [
		5698,
		9,
		3660,
		5698
	],
	"./blue-cards-slider.js": [
		5698,
		9,
		3660,
		5698
	],
	"./broker": [
		917,
		9,
		3660,
		917
	],
	"./broker-reg": [
		2342,
		9,
		2342
	],
	"./broker-reg.js": [
		2342,
		9,
		2342
	],
	"./broker.js": [
		917,
		9,
		3660,
		917
	],
	"./brokers-cost-calculation": [
		2988,
		9,
		3660,
		8857
	],
	"./brokers-cost-calculation.js": [
		2988,
		9,
		3660,
		8857
	],
	"./chart-patterns": [
		9324,
		7,
		9324
	],
	"./chart-patterns.js": [
		9324,
		7,
		9324
	],
	"./chart-series-ribbon": [
		4211,
		9,
		4211
	],
	"./chart-series-ribbon.js": [
		4211,
		9,
		4211
	],
	"./cheat-sheets-downloads": [
		6242,
		9,
		6242
	],
	"./cheat-sheets-downloads.js": [
		6242,
		9,
		6242
	],
	"./coach-cards": [
		474,
		7,
		474
	],
	"./coach-cards.js": [
		474,
		7,
		474
	],
	"./compounding-calculator": [
		935,
		9,
		3660,
		935
	],
	"./compounding-calculator.js": [
		935,
		9,
		3660,
		935
	],
	"./contact-form": [
		6069,
		9,
		6069
	],
	"./contact-form.js": [
		6069,
		9,
		6069
	],
	"./contest-page": [
		3560,
		9,
		3560
	],
	"./contest-page.js": [
		3560,
		9,
		3560
	],
	"./countdown-ribbon": [
		3694,
		9,
		3694
	],
	"./countdown-ribbon.js": [
		3694,
		9,
		3694
	],
	"./cup-of-coffee": [
		6739,
		9,
		6739
	],
	"./cup-of-coffee.js": [
		6739,
		9,
		6739
	],
	"./dunning-kruger-graph": [
		1631,
		9,
		1631
	],
	"./dunning-kruger-graph.js": [
		1631,
		9,
		1631
	],
	"./earnings-calculator": [
		2224,
		7,
		2224
	],
	"./earnings-calculator.js": [
		2224,
		7,
		2224
	],
	"./economic-calendar": [
		3397,
		9,
		3660,
		7040
	],
	"./economic-calendar.js": [
		3397,
		9,
		3660,
		7040
	],
	"./expert-coaches-slider": [
		1717,
		9,
		3660,
		1717
	],
	"./expert-coaches-slider.js": [
		1717,
		9,
		3660,
		1717
	],
	"./faq": [
		4502,
		7,
		4502
	],
	"./faq.js": [
		4502,
		7,
		4502
	],
	"./forecast-future": [
		5053,
		9,
		3660,
		5053
	],
	"./forecast-future.js": [
		5053,
		9,
		3660,
		5053
	],
	"./forex-mentors-hero": [
		5224,
		9,
		3660,
		5224
	],
	"./forex-mentors-hero.js": [
		5224,
		9,
		3660,
		5224
	],
	"./free-trading-plan-hero": [
		9929,
		9,
		9929
	],
	"./free-trading-plan-hero.js": [
		9929,
		9,
		9929
	],
	"./funded-traders": [
		5570,
		9,
		3660,
		5570
	],
	"./funded-traders.js": [
		5570,
		9,
		3660,
		5570
	],
	"./header-navigation": [
		428,
		9,
		3660,
		428
	],
	"./header-navigation.js": [
		428,
		9,
		3660,
		428
	],
	"./heat-map": [
		4294,
		9,
		3660,
		6259
	],
	"./heat-map.js": [
		4294,
		9,
		3660,
		6259
	],
	"./home-hero-questions": [
		5217,
		9,
		5217
	],
	"./home-hero-questions.js": [
		5217,
		9,
		5217
	],
	"./home-hero-slider": [
		3264,
		9,
		3660,
		3264
	],
	"./home-hero-slider.js": [
		3264,
		9,
		3660,
		3264
	],
	"./home-pricing": [
		5628,
		9,
		5628
	],
	"./home-pricing.js": [
		5628,
		9,
		5628
	],
	"./live-streams": [
		4314,
		9,
		4314
	],
	"./live-streams.js": [
		4314,
		9,
		4314
	],
	"./live-trading-streams": [
		5494,
		9,
		5494
	],
	"./live-trading-streams.js": [
		5494,
		9,
		5494
	],
	"./lot-size-calculator": [
		992,
		9,
		992
	],
	"./lot-size-calculator.js": [
		992,
		9,
		992
	],
	"./make-sense-markets": [
		4877,
		9,
		3660,
		4877
	],
	"./make-sense-markets.js": [
		4877,
		9,
		3660,
		4877
	],
	"./marketing-materials": [
		201,
		9,
		3660,
		201
	],
	"./marketing-materials.js": [
		201,
		9,
		3660,
		201
	],
	"./master-trading": [
		7874,
		7,
		7874
	],
	"./master-trading.js": [
		7874,
		7,
		7874
	],
	"./meet-the-mentors": [
		758,
		9,
		758
	],
	"./meet-the-mentors.js": [
		758,
		9,
		758
	],
	"./mentors-you-trust": [
		1013,
		9,
		3660,
		1013
	],
	"./mentors-you-trust.js": [
		1013,
		9,
		3660,
		1013
	],
	"./money-back": [
		2296,
		9,
		2296
	],
	"./money-back.js": [
		2296,
		9,
		2296
	],
	"./monte-carlo-simulation": [
		7420,
		9,
		3660,
		7420
	],
	"./monte-carlo-simulation.js": [
		7420,
		9,
		3660,
		7420
	],
	"./more-content": [
		5325,
		9,
		3660,
		5325
	],
	"./more-content.js": [
		5325,
		9,
		3660,
		5325
	],
	"./mt4-demo": [
		4445,
		9,
		3660,
		4445
	],
	"./mt4-demo.js": [
		4445,
		9,
		3660,
		4445
	],
	"./new-pricing": [
		3551,
		9,
		3551
	],
	"./new-pricing.js": [
		3551,
		9,
		3551
	],
	"./newsletter-full-width": [
		976,
		7,
		976
	],
	"./newsletter-full-width.js": [
		976,
		7,
		976
	],
	"./nfp-article": [
		1437,
		7,
		1437
	],
	"./nfp-article.js": [
		1437,
		7,
		1437
	],
	"./nfp-download": [
		7351,
		9,
		7351
	],
	"./nfp-download.js": [
		7351,
		9,
		7351
	],
	"./nfp-stream": [
		775,
		9,
		775
	],
	"./nfp-stream.js": [
		775,
		9,
		775
	],
	"./one-place": [
		8968,
		9,
		3660,
		8968
	],
	"./one-place.js": [
		8968,
		9,
		3660,
		8968
	],
	"./our-initiation-program": [
		2414,
		9,
		3660,
		2414
	],
	"./our-initiation-program.js": [
		2414,
		9,
		3660,
		2414
	],
	"./past-live-streams": [
		1307,
		9,
		1307
	],
	"./past-live-streams.js": [
		1307,
		9,
		1307
	],
	"./path-to-trading": [
		4549,
		9,
		3660,
		4549
	],
	"./path-to-trading.js": [
		4549,
		9,
		3660,
		4549
	],
	"./pip-calculator": [
		6489,
		9,
		6489
	],
	"./pip-calculator.js": [
		6489,
		9,
		6489
	],
	"./pricing-cards": [
		5122,
		7,
		5122
	],
	"./pricing-cards.js": [
		5122,
		7,
		5122
	],
	"./pricing-table": [
		777,
		7,
		777
	],
	"./pricing-table.js": [
		777,
		7,
		777
	],
	"./profit-calculator": [
		7471,
		9,
		7471
	],
	"./profit-calculator.js": [
		7471,
		9,
		7471
	],
	"./promo-ribbon": [
		9610,
		9,
		9610
	],
	"./promo-ribbon-stream": [
		8955,
		7,
		8955
	],
	"./promo-ribbon-stream.js": [
		8955,
		7,
		8955
	],
	"./promo-ribbon.js": [
		9610,
		9,
		9610
	],
	"./real-time-coaching": [
		4811,
		9,
		4811
	],
	"./real-time-coaching.js": [
		4811,
		9,
		4811
	],
	"./referral-data": [
		6630,
		7,
		6630
	],
	"./referral-data.js": [
		6630,
		7,
		6630
	],
	"./reset-password": [
		363,
		9,
		363
	],
	"./reset-password.js": [
		363,
		9,
		363
	],
	"./scrolling-ticker": [
		3368,
		9,
		3660,
		4357
	],
	"./scrolling-ticker.js": [
		3368,
		9,
		3660,
		4357
	],
	"./sidebar-heatmap": [
		3823,
		9,
		3660,
		3586
	],
	"./sidebar-heatmap.js": [
		3823,
		9,
		3660,
		3586
	],
	"./sidebar-home-nav": [
		4920,
		7,
		4920
	],
	"./sidebar-home-nav.js": [
		4920,
		7,
		4920
	],
	"./sidebar-nav": [
		9986,
		7,
		9986
	],
	"./sidebar-nav.js": [
		9986,
		7,
		9986
	],
	"./sign": [
		6725,
		9
	],
	"./sign.js": [
		6725,
		9
	],
	"./signals-table": [
		2190,
		9,
		2190
	],
	"./signals-table.js": [
		2190,
		9,
		2190
	],
	"./signout": [
		289,
		9,
		289
	],
	"./signout.js": [
		289,
		9,
		289
	],
	"./streams-countdown": [
		5381,
		9,
		3660,
		5381
	],
	"./streams-countdown.js": [
		5381,
		9,
		3660,
		5381
	],
	"./strength-heatmap-widget": [
		5097,
		9,
		3660,
		6164
	],
	"./strength-heatmap-widget.js": [
		5097,
		9,
		3660,
		6164
	],
	"./strength-meter": [
		4328,
		9,
		3660,
		4629
	],
	"./strength-meter.js": [
		4328,
		9,
		3660,
		4629
	],
	"./swap-calculator": [
		1122,
		9,
		1122
	],
	"./swap-calculator.js": [
		1122,
		9,
		1122
	],
	"./talent-awakened": [
		9141,
		9,
		9141
	],
	"./talent-awakened.js": [
		9141,
		9,
		9141
	],
	"./testimonials": [
		5656,
		9,
		3660,
		5656
	],
	"./testimonials.js": [
		5656,
		9,
		3660,
		5656
	],
	"./tools-slider": [
		9935,
		9,
		3660,
		9935
	],
	"./tools-slider.js": [
		9935,
		9,
		3660,
		9935
	],
	"./traders-joined": [
		2249,
		9,
		2249
	],
	"./traders-joined.js": [
		2249,
		9,
		2249
	],
	"./trading-competition-section": [
		7323,
		7,
		7323
	],
	"./trading-competition-section.js": [
		7323,
		7,
		7323
	],
	"./trading-room": [
		8923,
		9,
		3660,
		8923
	],
	"./trading-room.js": [
		8923,
		9,
		3660,
		8923
	],
	"./trading-tools": [
		957,
		9,
		3660,
		957
	],
	"./trading-tools.js": [
		957,
		9,
		3660,
		957
	],
	"./upcoming-live-streams": [
		6061,
		9,
		6061
	],
	"./upcoming-live-streams.js": [
		6061,
		9,
		6061
	],
	"./var-calculator": [
		7738,
		9,
		3660,
		7738
	],
	"./var-calculator.js": [
		7738,
		9,
		3660,
		7738
	],
	"./what-you-earn": [
		971,
		9,
		3660,
		971
	],
	"./what-you-earn.js": [
		971,
		9,
		3660,
		971
	],
	"./who-are-we": [
		5914,
		9,
		3660,
		5914
	],
	"./who-are-we.js": [
		5914,
		9,
		3660,
		5914
	],
	"./wp-sidebar-banner": [
		3277,
		7,
		3277
	],
	"./wp-sidebar-banner.js": [
		3277,
		7,
		3277
	],
	"./you-need-discipline": [
		3085,
		9,
		3085
	],
	"./you-need-discipline.js": [
		3085,
		9,
		3085
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6906;
module.exports = webpackAsyncContext;